import numeral from "numeral";
import "numeral/locales/pt-br";
numeral.locale("pt-br");

export const formatCurrency = (value, prefix = "R$") =>
  `${prefix} ${numeral(value).format("0,0.00")}`;

export const formatPointCurrency = (value) =>
  `${numeral(value).format("0,0.00")}`;

export const toString = (value) => {
  if (value || typeof value === "number") {
    return value.toString();
  }
  return String();
};

export const formatMoneyToRequest = (value) =>
  value ? checkPonto(value.split(".").join("").split(",").join(".")) : null;

export const formatMoneyToEditRequest = (value) =>
  checkWithZeroPonto(value.split(".").join("").split(",").join("."));

export const formatPago = (value) => (value === "S" ? "SIM" : "NÃO");

export const formatSituacao = (value) => {
  switch (value) {
    case "AVENCER":
      return "À VENCER";
    case "VENCENDONODIA":
      return "VENCENDO NO DIA";
    default:
      return value;
  }
};

export const formatPeriodicidade = (value) =>
  value === "AVISTA" ? "À VISTA" : value;

function checkPonto(values) {
  values = values.replace(".", "");
  values = values.replace(",", "");
  const resultado =
    values.substr(0, values.length - 2) +
    "." +
    values.substr(values.length - 2, values.length);
  return resultado === "0.00" || resultado === "00.00" || resultado === ".00"
    ? null
    : resultado;
}

function checkWithZeroPonto(values) {
  values = values.replace(".", "");
  values = values.replace(",", "");
  const resultado =
    values.substr(0, values.length - 2) +
    "." +
    values.substr(values.length - 2, values.length);
  return resultado;
}

export default toString;
